import { Skeleton } from "@/components/ui/skeleton";

export function PolicyCardSkeleton() {
  return (
    <div className="rounded-2xl bg-card flex flex-col h-full overflow-hidden border border-border">
      <div className="flex-1 flex flex-col p-5 gap-3">
        {/* Status pill + version row */}
        <div className="flex items-center justify-between">
          <Skeleton variant="shimmer" className="h-5 w-24 rounded-full" />
          <Skeleton variant="shimmer" className="h-4 w-6" />
        </div>

        {/* Title */}
        <div className="space-y-2">
          <Skeleton variant="shimmer" className="h-6 w-4/5" />
          <Skeleton variant="shimmer" className="h-6 w-3/5" />
        </div>

        {/* Department badge */}
        <Skeleton variant="shimmer" className="h-5 w-28 rounded-full" />

        {/* Meta rows */}
        <div className="mt-auto space-y-1.5 pt-1">
          <Skeleton variant="shimmer" className="h-3.5 w-2/3" />
          <Skeleton variant="shimmer" className="h-3.5 w-1/2" />
        </div>
      </div>

      {/* Action button */}
      <div className="px-5 pb-5 pt-0">
        <div className="h-[1px] bg-border mb-4" />
        <Skeleton variant="shimmer" className="h-9 w-full rounded-full" />
      </div>
    </div>
  );
}
